const formConfig = {
  mapper: (element) => ({
    id: element.id || '',
  }),
  title: 'Confirm',

};

export { formConfig };
